import { Config, EntityDialog, ErrorHandling, HtmlContentEditor, getjQuery, notifyInfo } from "@serenity-is/corelib";
import { gridDefaults } from "@serenity-is/sleekgrid";
import { siteLanguageList } from "./Helpers/LanguageList";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { IdleTimeoutHandler } from "./IdleTimeoutHandler";

Config.rootNamespaces.push('eAbhiyantriki');
EntityDialog.defaultLanguageList = siteLanguageList;
HtmlContentEditor.CKEditorBasePath = "~/Serenity.Assets/Scripts/ckeditor/";
gridDefaults.useCssVars = false;

let $ = getjQuery();
if ($?.fn?.colorbox) {
    $.fn.colorbox.settings.maxWidth = "95%";
    $.fn.colorbox.settings.maxHeight = "95%";
}

window.onerror = ErrorHandling.runtimeErrorHandler;
window.addEventListener('unhandledrejection', ErrorHandling.unhandledRejectionHandler);

// Initialize IdleTimeout for automatic user signout after inactivity
// 30 minutes (1800 seconds) of inactivity with 60 seconds warning
new IdleTimeoutHandler({
    activityTimeout: 1800, // 30 minutes of inactivity
    warningDuration: 60,   // Show warning 60 seconds before signout
    signoutUrl: "/Account/Signout"
});

//add signalR BEGIN

// The HubConnectionBuilder class creates a new builder for 
// configuring the server connection. 
// The withUrl function configures the hub URL.
// Hub URL was defined in Startup.cs 
const connection = new HubConnectionBuilder()
    .withUrl("/notificationhub")
    .withAutomaticReconnect()
    .build();

// Listening to a message with the name 'notifyMessage'
// and display the message using Q.notifyInfo
connection.on("notifyMessage", (message) => {
    notifyInfo(message);
});

try {
    connection.start();
} catch (e) {
    console.error(e.toString());
}
//add signalR END